<div class="flex h-full w-full flex-col">
  <app-toolbox
    [sections]="toolboxSections()"
    [searchConfig]="searchCfg"
    [searchPlaceholder]="searchPlaceholder()"
    [(searchQuery)]="search" />
  <app-cards-list
    class="flex min-h-0 w-full flex-1 flex-col overflow-y-auto"
    [config]="solversListConfig()"></app-cards-list>
</div>
